import Base from '@studiometa/js-toolkit';
import videojs from 'video.js';
import videojsOverlay from 'videojs-overlay';

/**
 * @typedef {Object} VideoPlayerRef
 * @property {HTMLElement} video
 */

/**
 * @typedef {Object} VideoPlayerInterface
 * @property {VideoPlayerRef} $refs
 */

/**
 * Homepage class.
 */
export default class VideoPlayer extends Base {
  /**
   * Class config
   * @type {Object}
   */
  static config = {
    name: 'VideoPlayer',
    refs: ['video'],
  };

  /**
   * Initialize the component's behavior.
   *
   * @this {VideoPlayer & VideoPlayerInterface}
   */
  mounted() {
    videojs.registerPlugin('overlay', videojsOverlay);

    const player = videojs(this.$refs.video, {
      controls: true,
      fluid: true,
    });

    const overlayContent = document.createElement('p');
    overlayContent.innerHTML = '';

    player.overlay({
      overlays: [
        {
          content: overlayContent,
          start: 'ready',
          end: 'play',
          align: 'bottom-left',
        },
      ],
    });
  }

  /**
   * Unbind all events on destroy.
   *
   * @this {VideoPlayer & VideoPlayerInterface}
   * @return {VideoPlayer} The Video instance.
   */
  destroyed() {
    return this;
  }
}
